import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
import { usePermissions } from '@/plugins/permissions';

import HomeView from '../views/dashboard/HomeView.vue';
import UserLogin from '../views/login/UserLogin.vue';
import FormularioRegistrarse from '../views/login/FormularioRegistrarse .vue';
import EditUser from '../views/administracion/EditUser.vue';
import UsuariosPanel from '@/views/usuarios/UsuariosPanel.vue';

import DashboardProductos from '@/views/almacen/DashboardProductos.vue';
import DashboardUnidades from '@/views/almacen/DashboardUnidades.vue';
import DashboardRelaciones from '@/views/almacen/DashboardRelaciones.vue';
import DashboardCentrosActivacion from '@/views/almacen/DashboardCentrosActivacion.vue';
import DashboardAlmacenes from '@/views/almacen/DashboardAlmacenes.vue';
import DashboardOrdenesEntrega from '@/views/ordenes/DashboardOrdenesEntrega.vue';
import DashboardCrearOrdenEntrega from '@/views/almacen/DashboardCrearOrdenEntrega.vue';
import VerOrdenEntrega from '@/views/almacen/VerOrdenEntrega.vue';
import DashboardEditarOrdenEntrega from '@/views/ordenes/DashboardEditarOrdenEntrega.vue';
import ListaProductosAlmacenEntrega from '@/views/ordenes/ListaProductosAlmacenEntrega.vue';
import OrdenesRecoleccion from '@/views/ordenes/OrdenesRecoleccion.vue';
import AjustesOrden from '@/views/ordenes/AjustesOrden.vue';
import InventarioGlobal from '@/views/inventario/InventarioGlobal.vue';
import HistorialUnidades from '@/views/almacen/HistorialUnidades.vue';
import RelacionUnidades from '@/components/almacen/unidades/RelacionUnidades.vue';
import FormularioOrdenEntrega from '@/views/ordenes/FormularioOrdenEntrega.vue';
import DashboardOrdenesEntrada from '@/views/almacen/DashboardOrdenesEntrada.vue';
import VerOrdenEntrada from '@/views/ordenesEntrada/VerOrdenEntrada.vue';
import CrearOrdenEntrada from '@/views/ordenesEntrada/CrearOrdenEntrada.vue';

const APP_NAME = 'Sistema de Almacén';

const baseUrl =
  typeof process !== 'undefined' &&
  process.env &&
  process.env.BASE_URL
    ? process.env.BASE_URL
    : '/';

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView,
    meta: {
      requiresAuth: true,
      title: 'Inicio',
    },
  },
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin,
    meta: {
      title: 'Iniciar sesión',
    },
  },
  {
    path: '/registrarse/:clave?',
    name: 'FormularioRegistrarse',
    component: FormularioRegistrarse,
    props: (route) => ({ claveProp: route.params.clave }),
    meta: {
      title: 'Registrarse',
    },
  },
  {
    path: '/dashboard',
    name: 'UserDashboard',
    component: HomeView,
    meta: {
      requiresAuth: true,
      title: 'Dashboard',
    },
  },
  {
    path: '/dashboard/user/edit/:token',
    name: 'EditUser',
    component: EditUser,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Editar usuario',
    },
  },
  {
    path: '/dashboard/usuarios',
    name: 'UsuariosPanel',
    component: UsuariosPanel,
    meta: {
      requiresAuth: true,
      title: 'Usuarios',
    },
  },
  {
    path: '/dashboard/orden-entrada',
    name: 'DashboardOrdenesEntrada',
    component: DashboardOrdenesEntrada,
    meta: {
      requiresAuth: true,
      title: 'Órdenes de entrada',
    },
  },
  {
    path: '/dashboard/ver-orden-entrada/:id',
    name: 'VerOrdenEntrada',
    component: VerOrdenEntrada,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Detalle de orden de entrada',
    },
  },
  {
    path: '/dashboard/crear-orden-entrada',
    name: 'CrearOrdenEntrada',
    component: CrearOrdenEntrada,
    meta: {
      requiresAuth: true,
      title: 'Crear orden de entrada',
    },
  },
  {
    path: '/almacen/ordenes-recoleccion/ver/:idOrden',
    name: 'VerOrdenRecoleccion',
    component: () => import('../views/ordenes/VerOrdenRecoleccion.vue'),
    meta: {
      requiresAuth: true,
      title: 'Recolección de orden de entrega',
    },
  },
  {
    path: '/dashboard/productos',
    name: 'DashboardProductos',
    component: DashboardProductos,
    meta: {
      requiresAuth: true,
      title: 'Productos',
    },
  },
  {
    path: '/dashboard/unidades',
    name: 'DashboardUnidades',
    component: DashboardUnidades,
    meta: {
      requiresAuth: true,
      title: 'Unidades y seriales',
    },
  },
  {
    path: '/dashboard/relaciones',
    name: 'DashboardRelaciones',
    component: DashboardRelaciones,
    meta: {
      requiresAuth: true,
      title: 'Relaciones de unidades',
    },
  },
  {
    path: '/dashboard/centros-activacion',
    name: 'DashboardCentrosActivacion',
    component: DashboardCentrosActivacion,
    meta: {
      requiresAuth: true,
      title: 'Centros de activación',
    },
  },
  {
    path: '/dashboard/almacenes',
    name: 'DashboardAlmacenes',
    component: DashboardAlmacenes,
    meta: {
      requiresAuth: true,
      title: 'Almacenes',
    },
  },
  {
    path: '/dashboard/ordenes-entrega',
    name: 'DashboardOrdenesEntrega',
    component: DashboardOrdenesEntrega,
    meta: {
      requiresAuth: true,
      title: 'Órdenes de entrega',
    },
  },
  {
    path: '/dashboard/ordenes-entrega/crear',
    alias: '/dashboard/crear-orden-entrega',
    name: 'DashboardCrearOrdenEntrega',
    component: DashboardCrearOrdenEntrega,
    meta: {
      requiresAuth: true,
      title: 'Crear orden de entrega',
    },
  },
  {
    path: '/dashboard/ordenes-entrega/:id/productos-almacen',
    name: 'ListaProductosAlmacenEntrega',
    component: ListaProductosAlmacenEntrega,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Productos de almacén para surtido',
    },
  },
  {
    path: '/dashboard/ordenes-entrega/:id',
    name: 'VerOrdenEntrega',
    component: VerOrdenEntrega,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Detalle de orden de entrega',
    },
  },
  {
    path: '/dashboard/ordenes-entrega/editar/:id',
    alias: '/dashboard/editar-ordene-entrega/:id',
    name: 'DashboardEditarOrdenEntrega',
    component: DashboardEditarOrdenEntrega,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Editar orden de entrega',
    },
  },
  {
    path: '/dashboard/ordenes-recoleccion',
    name: 'OrdenesRecoleccion',
    component: OrdenesRecoleccion,
    meta: {
      requiresAuth: true,
      title: 'Órdenes de recolección',
    },
  },
  {
    path: '/dashboard/ajustes-orden',
    name: 'AjustesOrden',
    component: AjustesOrden,
    meta: {
      requiresAuth: true,
      title: 'Ajustes de orden',
    },
  },
  {
    path: '/dashboard/inventario',
    name: 'InventarioGlobal',
    component: InventarioGlobal,
    meta: {
      requiresAuth: true,
      title: 'Inventario global',
    },
  },
  {
    path: '/dashboard/historial-unidades',
    name: 'HistorialUnidades',
    component: HistorialUnidades,
    meta: {
      requiresAuth: true,
      title: 'Historial de unidades',
    },
  },
  {
    path: '/dashboard/relacion-unidades',
    name: 'RelacionUnidades',
    component: RelacionUnidades,
    meta: {
      requiresAuth: true,
      title: 'Relacionar unidades',
    },
  },
  {
    path: '/dashboard/ordenes/crear-orden',
    name: 'FormularioOrdenEntrega',
    component: FormularioOrdenEntrega,
    meta: {
      requiresAuth: true,
      title: 'Formulario de orden de entrega',
    },
  },
];

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes,
});

const { roleState, reloadRole } = usePermissions();

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (!requiresAuth) {
    return next();
  }

  const user = store.state.user;
  const userToken = user && user.token;
  const roleToken = store.state.roleToken;

  if (!user || !userToken) {
    return next('/login');
  }

  if (!roleToken) {
    return next('/login');
  }

  try {
    const comingFromLogin = from.name === 'UserLogin';

    if (!roleState.roleLoaded || !roleState.role || comingFromLogin) {
      await reloadRole(store, false);
    }

    if (!roleState.role) {
      return next('/login');
    }

    return next();
  } catch (error) {
    console.error('[router] Error al validar rol:', error);
    return next('/login');
  }
});

router.afterEach((to) => {
  const nearestWithTitle = [...to.matched].reverse().find((r) => r.meta && r.meta.title);
  const pageTitle = nearestWithTitle?.meta?.title;

  if (typeof document !== 'undefined') {
    document.title = pageTitle ? `${pageTitle} | ${APP_NAME}` : APP_NAME;
  }
});

export default router;